import React from "react";
import { useNavigate } from "react-router-dom";

import noPermissionImg from "assets/no_permission.jpg";

const LayoutView: React.FC = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate("/login");
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f5f5f5",
        padding: 20,
      }}
    >
      <div
        style={{
          textAlign: "center",
          background: "white",
          padding: "40px 60px",
          borderRadius: 12,
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        {/* Image */}
        <img
          src={noPermissionImg}
          alt="No Permission"
          style={{ width: 180, marginBottom: 20 }}
        />

        {/* Title */}
        <h2 style={{ marginBottom: 10, color: "#333" }}>No Permission</h2>

        {/* Message */}
        <p style={{ color: "#777", fontSize: 16, maxWidth: 350, margin: "0 auto 20px" }}>
          You do not have permission to access this page.
          Please contact admin to enable permissions.
        </p>

        {/* Back Button */}
        <button
          onClick={handleBack}
          style={{
            padding: "10px 22px",
            backgroundColor: "#1677ff",
            color: "white",
            border: "none",
            borderRadius: 6,
            cursor: "pointer",
            fontSize: 15,
            marginTop: 10,
          }}
        >
          Back to Home
        </button>
      </div>
    </div>
  );
};

export default LayoutView;
